var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6879 1.68751C15.9379 0.812512 14.8129 0.375012 13.6254 0.500012C12.8129 0.562512 12.0629 1.00001 11.4379 1.62501L2.75039 10.25C2.37539 10.625 2.06289 11.125 1.87539 11.625L0.500391 15.625C0.312891 16.1875 0.437891 16.75 0.875391 17.125C1.12539 17.375 1.50039 17.5625 1.87539 17.5625C2.06289 17.5625 2.18789 17.5625 2.37539 17.5L6.37539 16.125C6.87539 15.9375 7.37539 15.625 7.75039 15.25L16.4379 6.56251C17.7504 5.25001 17.8129 3.00001 16.6879 1.68751ZM1.93789 16.3125C1.81289 16.375 1.75039 16.3125 1.75039 16.25C1.68789 16.1875 1.68789 16.125 1.68789 16.0625L2.93789 12.4375L5.56289 15.0625L1.93789 16.3125ZM15.5004 5.68751L6.81289 14.375C6.75039 14.4375 6.75039 14.4375 6.68789 14.4375L3.50039 11.25C3.50039 11.1875 3.56289 11.1875 3.56289 11.125L12.3129 2.50001C12.7504 2.06251 13.2504 1.81251 13.7504 1.75001C14.5004 1.68751 15.2504 1.93751 15.7504 2.50001C16.5004 3.37501 16.3754 4.87501 15.5004 5.68751Z",
    fill: "#2C2C2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c904225cddcc98d32a4209ae342252ed.svg";
export { ForwardRef as ReactComponent };